import { render } from "./ManagerReviewTab.vue?vue&type=template&id=3b95a350&scoped=true"
import script from "./ManagerReviewTab.vue?vue&type=script&lang=js"
export * from "./ManagerReviewTab.vue?vue&type=script&lang=js"

import "./ManagerReviewTab.vue?vue&type=style&index=0&id=3b95a350&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b95a350"]])

export default __exports__